module.exports = __webpack_public_path__ + "@/assets/img/logo-ipp.380e9e0b.png";